import React from 'react';
import {Box, Flex, Grid, Type} from 'mesh-component-library';
import StyledCCOffer from "./cc-offer.styles";
import { useLocale } from '../../contexts/LocaleContext';
import { TRANSLATION_CONSTANTS } from '../../app-consts/translations';
import PEP_CreditCardIcon from '../../assets/PEP_CreditCardIcon.svg';
import { datadogRum } from '@datadog/browser-rum';

interface CreditCardOfferProps {
  displayCode: string;
}

const CreditCardOffer = ({displayCode}: CreditCardOfferProps) => {
  const getTranslatedText = useLocale();

  return (
    <StyledCCOffer>
      <Grid verticalAlign="middle">
        <Grid.Column col={9}>
          <Type
            element="h3"
            size="xl"
            weight="semibold"
          >
            {getTranslatedText(TRANSLATION_CONSTANTS.CREDIT_CARD_OFFER_TITLE, displayCode)}
          </Type>
          <Type element="p">
            {getTranslatedText(TRANSLATION_CONSTANTS.CREDIT_CARD_OFFER_CONTENT, displayCode)}
          </Type>
        </Grid.Column>
        <Grid.Column col={3} 
         utils={{
            hrLeft: "md",
          }}>
          <Flex justifyContent="end">
            <Box
              className="cc-o-box"
              hasBorder={false}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={PEP_CreditCardIcon} alt="Credit Card" style={{ width: '80px', height: '45px'}} />
              </div>
              <div style={{ marginTop: '6px', textAlign: 'end' }}>
                <a
                  onClick={() => datadogRum.addAction('Pep Boys Credit Card Offer clicked')}
                  target="_blank"
                  className="cc-o"
                  href="https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=3CFA7859F753366B9F1906A2283DB94553C347EA64DFDD35&client=Pep%20Boys"
                >
                  {getTranslatedText(TRANSLATION_CONSTANTS.CREDIT_CARD_OFFER_PREQUALIFY, displayCode)}
                </a>
              </div>
            </Box>
          </Flex>
        </Grid.Column>
      </Grid>
    </StyledCCOffer>
  );
};

export default CreditCardOffer;
